module.exports = __webpack_public_path__ + "newsletter/Components/PocketHitsSignup/images/publishers/logo-cityLab.9e0bd36a41f15352795a0c3e7906a3c0.png";